import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

export const DIALOG_TYPE = 'popup-blocked';

@Component({
  selector: 'app-popup-blocked-dialog',
  templateUrl: './popup-blocked-dialog.component.html',
  styleUrls: ['./popup-blocked-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupBlockedDialogComponent implements OnInit {
  dialogType: string;

  constructor() {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
  }
}
